import { render } from "./ProfileCatalogueAdminView.vue?vue&type=template&id=06106f56&scoped=true"
import script from "./ProfileCatalogueAdminView.vue?vue&type=script&lang=js"
export * from "./ProfileCatalogueAdminView.vue?vue&type=script&lang=js"

import "./ProfileCatalogueAdminView.vue?vue&type=style&index=0&id=06106f56&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06106f56"]])

export default __exports__